import { useEffect, useState } from "react";

const KEY = "showSignatureInLabPrint";
const EVENT_NAME = "showSignatureInLabPrintChanged";

// eslint-disable-next-line import/prefer-default-export
export const useShowSignatureInLabPrint = (): {
  showSignatureInLabPrint: boolean;
  setShowSignatureInLabPrint: (value: boolean) => void;
} => {
  const [showSignatureInLabPrint, setShowSignatureInLabPrint] = useState<boolean>(() => {
    const stored = localStorage.getItem(KEY);
    return stored === null ? true : stored === "true";
  });

  // use effects
  useEffect(() => {
    localStorage.setItem(KEY, String(showSignatureInLabPrint));
    window.dispatchEvent(new Event(EVENT_NAME));
  }, [showSignatureInLabPrint]);

  useEffect(() => {
    const sync = () => {
      setShowSignatureInLabPrint(localStorage.getItem(KEY) === "true");
    };

    const handleStorage = (e: StorageEvent) => {
      if (e.key === KEY) {
        sync();
      }
    };

    window.addEventListener(EVENT_NAME, sync);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener(EVENT_NAME, sync);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  return { showSignatureInLabPrint, setShowSignatureInLabPrint };
};
